import type { FilesProxySchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

export const getProxyFrameRate = (
  proxy: FilesProxySchemaWithIdNullable | undefined,
) => {
  if (proxy?.format === 'IMAGE') {
    return 0;
  }
  if (!proxy?.frame_rate) {
    return undefined;
  }
  const fps = Number(proxy.frame_rate);
  if (fps <= 0) {
    return undefined;
  }
  return fps;
};
